<template>
  <div>
    <div class="surcharge-email">
      <Tabs :items="surchargeTabItems" @onClick="onTabActivated" />
    </div>
    <div v-if="currentSelectedTab === 'qsr-emails'" class="email-activities">
      <div v-if="dataLength">
        <div
          v-for="(item, index) in emailActivitiesState"
          :key="index"
          class="email-activities__container">
          <accordian
            :expanded="item.expanded"
            :item="item"
            :index="index"
            @onCardToggle="onAccordianToggle">
            <div
              slot="accordian-header-content"
              class="email-activities__container__accordian-header">
              <div
                class="email-activities__container__accordian-header__content">
                <div
                  class="email-activities__container__accordian-header__content__info">
                  <span
                    class="email-activities__container__accordian-header__content__info__name--bold">
                    {{ item?.from?.emailAddress?.name }}
                  </span>
                  <span
                    v-tooltip="formatDate(item.receivedDateTime)"
                    class="email-activities__container__accordian-header__content__info__name--ellipsis">
                    {{ formatDate(item.receivedDateTime) }}
                  </span>
                </div>
                <div
                  class="email-activities__container__accordian-header__content__info">
                  <span
                    class="email-activities__container__accordian-header__content__info__name--grey">
                    From
                  </span>
                  <span
                    v-tooltip="formatDate(item?.from?.emailAddress?.address)"
                    class="email-activities__container__accordian-header__content__info__name--ellipsis">
                    {{ item?.from?.emailAddress?.address }}
                  </span>
                </div>
                <div
                  class="email-activities__container__accordian-header__content__info">
                  <span
                    class="email-activities__container__accordian-header__content__info__name--grey">
                    To
                  </span>
                  <span
                    v-tooltip="
                      formatDate(getToRecipientsList(item.toRecipients))
                    "
                    class="email-activities__container__accordian-header__content__info__name--ellipsis">
                    {{ getToRecipientsList(item.toRecipients) }}
                  </span>
                </div>
                <div
                  class="email-activities__container__accordian-header__content__info subject">
                  <span
                    class="email-activities__container__accordian-header__content__info__name--grey">
                    Subject
                  </span>
                  <span
                    v-tooltip="formatDate(item.subject)"
                    class="email-activities__container__accordian-header__content__info__name--ellipsis">
                    {{ item.subject }}
                  </span>
                </div>
              </div>
            </div>
            <div
              v-if="item.expanded && emailContent"
              slot="accordian-body"
              class="email-activities__container__accordian-body">
              <div class="email-activities__container__accordian-body__item">
                <span
                  class="email-activities__container__accordian-body__item__title">
                  <span>TP Doc Number</span>
                  <Button
                    v-tooltip="'Download Email'"
                    appearance="tertiary"
                    icon="tray-arrow-down"
                    icon-position="left"
                    icon-only
                    class="email-activities__container__accordian-body__item__title__download"
                    @onClick="
                      downloadSurchargeEmail(item?.id, item?.subject)
                    " />
                </span>
                <span
                  class="email-activities__container__accordian-body__item__value">
                  {{ caseData?.tpDocumentNumber }}
                </span>
              </div>
              <div class="email-activities__container__accordian-body__item">
                <span
                  class="email-activities__container__accordian-body__item__title">
                  Subject
                </span>
                <span
                  class="email-activities__container__accordian-body__item__value">
                  {{ item.subject }}
                </span>
              </div>
              <div class="email-activities__container__accordian-body__item">
                <span
                  class="email-activities__container__accordian-body__item__title">
                  Email content
                </span>
                <div
                  class="email-activities__container__accordian-body__item__value"
                  v-html="item?.body?.content"></div>
              </div>
              <!-- <attachment-list
              v-if="emailContent.attachments && emailContent.attachments.length"
              :attachments="getFormattedAttachments(emailContent.attachments)"
              title="Email attachments"
              has-download
              :has-delete="false"
              v-on="$listeners" /> -->
            </div>
          </accordian>
        </div>
      </div>

      <h4 v-else class="email-activities__not-found">No Email Found</h4>
      <div class="email-activities__pagination">
        <Button
          v-if="skipTokenList.length > 1"
          :label="'Previous'"
          appearance="tertiary"
          icon="chevron-left"
          icon-position="left"
          class="email-activities__pagination__previous"
          @onClick="fetchSurchargeEmails(true)" />
        <Button
          v-if="currentSkipToken.length"
          :label="'Next'"
          appearance="tertiary"
          icon="chevron-right"
          icon-position="right"
          class="email-activities__pagination__next"
          @onClick="fetchSurchargeEmails()" />
      </div>
    </div>
    <div v-else-if="currentSelectedTab === 'sfdc-emails'">
      <sfdc-emails
        :case-data="caseData"
        :sfdc-case-id="mailIdToView"
        @showLoader="showLoaderInSurchargeTab"
        @hideLoader="hideLoaderInSurchargeTab" />
    </div>
  </div>
</template>

<script>
//Actions
import { fileActions } from "@/actions";
import { disputeActions } from "@/actions";
// Util
import { format } from "date-fns";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import { getMsalIdToken } from "@/utils/helpers";
import { saveAs } from "file-saver";
import SfdcEmails from "@/components/SurchargeEmails/SFDCEmails/SFDCEmails.vue";

// constants
import { emailStatusMapping } from "@/config/isrConstant.js";
// Constants
import { surchargeTabItems } from "@/config/disputeDataConstant.js";

export default {
  name: "SurchargeEmails",
  components: {
    SfdcEmails,
  },
  props: {
    emailActivities: {
      type: Array,
      default: () => [],
    },
    caseData: {
      type: Object,
      default: () => {},
    },
    currentSkipToken: {
      type: String,
      default: () => "",
    },
    selectedTab: {
      type: String,
      default: () => "",
    },
    mailId: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      surchargeTabItems,
      emailContent: null,
      emailStatusMapping,
      emailCache: [],
      skipToken: [],
      currentToken: "",
      skipTokenList: [],
      clickedOnPrevBtn: false,
      currentSelectedTab: this.selectedTab || "qsr-emails",
      emailActivitiesState: this.emailActivities,
      mailIdToView: this.mailId,
    };
  },
  computed: {
    dataLength() {
      return this.emailActivitiesState?.length > 0;
    },
  },
  watch: {
    emailActivities() {
      this.emailActivitiesState = this.emailActivities;
      if (this.selectedTab == "sfdc-emails") {
        this.surchargeTabItems = this.surchargeTabItems?.map((item) => {
          return { ...item, active: item?.id == "sfdc-emails" ? true : false };
        });
      } else if (this.selectedTab == "qsr-emails") {
        this?.emailActivitiesState?.forEach(async (item, inx) => {
          if (this.mailId?.indexOf(item?.id) > -1) {
            await this.onAccordianToggle(item, inx);
          }
        });
      }
    },
    mailId() {
      this.mailIdToView = this.mailId;
    },
    currentSkipToken() {
      if (
        this.skipTokenList?.indexOf(this.currentSkipToken) === -1 &&
        !this.clickedOnPrevBtn
      ) {
        this.skipTokenList?.push(this.currentSkipToken);
      }
    },
  },
  async mounted() {},
  methods: {
    showLoaderInSurchargeTab() {
      this.$emit("showLoader", "tabContainer");
    },
    hideLoaderInSurchargeTab() {
      this.$emit("hideLoader");
    },
    onTabActivated({ selectedItemId, updatedTabData }) {
      this.$emit("clearViewMailId");
      this.mailIdToView = "";
      this.currentSelectedTab = selectedItemId;
      this.surchargeTabItems = updatedTabData;
      if (selectedItemId === "qsr-emails") {
        this.$emit("fetchSurchargeEmails", "");
      } else {
        this.$emit("clearSkipToken");
      }
    },
    fetchSurchargeEmails(isPreviousButtonClicked = false) {
      this.clickedOnPrevBtn = isPreviousButtonClicked;
      if (isPreviousButtonClicked) {
        this.$emit(
          "fetchSurchargeEmails",
          this.skipTokenList?.[
            this?.skipTokenList?.indexOf(this.currentSkipToken) - 2
          ]
        );
        this.skipTokenList?.pop();
      } else {
        this.$emit("fetchSurchargeEmails", this.currentSkipToken);
      }
    },
    formatDate(date) {
      try {
        return date
          ? format(new Date(`${date}`), "dd-MMM-yyyy hh:mm a")
          : "N/A";
      } catch (err) {
        return date;
      }
    },
    async onAccordianToggle(clickedItem, index) {
      const emailDataFromCache = this.emailCache.find(
        (item) => item.id === clickedItem.id
      );
      if (!clickedItem?.expanded && !emailDataFromCache) {
        try {
          this.$emit("hideLoader");
          this.$emit("showLoader", "tabContainer");
          const { data } = await AxiosFetchForMsal(
            disputeActions.getSurchargeEmailDetails(
              clickedItem.id,
              `Bearer ${await getMsalIdToken(this)}`
            )
          );
          this.emailContent = data;
          this.emailCache.push(data);
          event.stopPropagation();
          this.$emit("hideLoader");
        } catch (error) {
          this.$emit("hideLoader");
          console.error(error);
        }
      } else {
        this.emailContent = emailDataFromCache;
      }
      let newArray = [...this.emailActivitiesState];
      newArray[index] = {
        ...clickedItem,
        expanded: !clickedItem?.expanded,
      };
      this.emailActivitiesState = newArray;
    },
    getToRecipientsList(toRecipients) {
      return toRecipients
        ?.map((item) => item?.emailAddress?.address)
        ?.join(",");
    },
    getFormattedAttachments(data) {
      return data.map((item) => ({
        fileName: item?.name,
        type: item?.file_extension || item?.name.split(".").pop(),
        id: item?.id,
      }));
    },
    async downloadSurchargeEmail(id, subject) {
      try {
        this.$emit("hideLoader");
        this.$emit("showLoader", "tabContainer");
        const { data } = await AxiosFetchForMsal(
          fileActions.downloadSurchargeEmail(
            id,
            `Bearer ${await getMsalIdToken(this)}`
          )
        );
        saveAs(data, `${subject}.eml`);
        this.$emit("hideLoader");
      } catch (error) {
        this.$emit("hideLoader");
        console.error(error);
      }
    },
    test() {
      alert("");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";
.email-activities {
  background: var(--Gray-50);
  &__not-found {
    color: var(--Gray-900);
    margin: 1rem;
  }
  &__pagination {
    display: flex;
    margin-top: 16px;
    justify-content: flex-end;
    &__previous {
      &:hover {
        background-color: rgba(66, 176, 213, 0.5) !important;
        color: #fff !important;
      }
    }
    &__next {
      margin-left: 16px;
      &:hover {
        background-color: rgba(66, 176, 213, 0.5) !important;
        color: #fff !important;
      }
    }
  }
  &__container {
    margin: 1rem 0;
    cursor: pointer;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      width: 20px;
      height: 20px;
      background-color: var(--Blue-800);
      border-radius: 24px;
      margin-top: 32px;
    }

    &::after {
      content: "";
      height: calc(100% + 8px);
      position: absolute;
      top: 42px;
      left: 9px;
      width: 2px;
      background-color: var(--Blue-800);
    }

    &:last-child {
      margin-bottom: 0;

      &::after {
        content: none;
      }
    }

    &__accordian-header {
      display: flex;
      align-items: center;

      &__content {
        display: flex;
        align-items: center;

        @include media("<tablet") {
          flex-direction: column;
        }

        &__info {
          display: flex;
          flex-direction: column;
          margin-right: 2rem;
          font-family: "Maersk Text";
          font-size: 14px;
          color: var(--Blue-900-Darkest);
          text-transform: capitalize;
          width: 180px;
          &__name {
            font-size: 16px;
            margin-bottom: 4px;
            &--bold {
              font-weight: bold;
            }
            &--grey {
              font-weight: bold;
              color: var(--Gray-600);
            }
            &--ellipsis {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .subject {
          width: 380px;
        }
      }
    }

    &__accordian-body {
      padding: 1rem;
      border: 1px solid var(--Gray-200);
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      display: flex;
      flex-direction: column;
      margin-left: 60px;
      cursor: default;

      @include media("<tablet") {
        margin-left: 40px;
      }

      &__item {
        display: flex;
        margin-bottom: 16px;
        flex-direction: column;
        &__title {
          color: var(--Gray-600);
          margin-bottom: 4px;
          font-size: 14px;
          &__download {
            float: right;
            cursor: pointer;
          }
          i {
            font-style: normal;
          }
        }
        &__value {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
